var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSalesRepBaseData, GetAllWholesalePrices, getSalesRepSTReports } from "../../reduxStore/actions/salesRepDataAction";
import { getSTOrderDetailsDefaultDateRangeApiKeys, ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE } from "../model/STOrderDetailsModel";
import { isLoading, checkDrawerOpen } from "../../services/behaviorSubjectService";
import { defaults } from "chart.js";
import store from "../../reduxStore/store";
import { TableRow, TableCell, TableBody, Typography, useMediaQuery, Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDeviceQueries, formatAmount } from "../../shared/Utilites";
defaults.font.size = 12;
defaults.font.family = "'Inter', sans-serif";
var _stReportsBootstrapDispatched = false;
export function DashboardBL() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var storeBaseData = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.salesRepData) === null || _a === void 0 ? void 0 : _a.baseData; });
    var selectFeatures = ((_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.select) ? (_e = (_d = (_c = store === null || store === void 0 ? void 0 : store.getState()) === null || _c === void 0 ? void 0 : _c.salesRepData) === null || _d === void 0 ? void 0 : _d.baseData) === null || _e === void 0 ? void 0 : _e.select : {};
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var loggedInRepData = useSelector(function (state) { var _a; return (_a = state === null || state === void 0 ? void 0 : state.salesRepData) === null || _a === void 0 ? void 0 : _a.loggedInRepDetails; });
    var shopCurrency = loggedInRepData === null || loggedInRepData === void 0 ? void 0 : loggedInRepData.shopCurrency;
    var currency = loggedInRepData === null || loggedInRepData === void 0 ? void 0 : loggedInRepData.currency;
    var isDesktop = useMediaQuery("(min-width: 1360px)");
    var setChartDataFromStore = (_h = (_g = (_f = store === null || store === void 0 ? void 0 : store.getState()) === null || _f === void 0 ? void 0 : _f.salesRepData) === null || _g === void 0 ? void 0 : _g.baseData) !== null && _h !== void 0 ? _h : {};
    var ShopBusinessName = (_m = (_l = (_k = (_j = store === null || store === void 0 ? void 0 : store.getState()) === null || _j === void 0 ? void 0 : _j.salesRepData) === null || _k === void 0 ? void 0 : _k.baseData) === null || _l === void 0 ? void 0 : _l.ShopBusinessName) !== null && _m !== void 0 ? _m : (_o = loggedInRepData === null || loggedInRepData === void 0 ? void 0 : loggedInRepData.shopName) === null || _o === void 0 ? void 0 : _o.replace(/.myshopify.com/g, "");
    var baseBarLabel = [t("ClientInvoice"), t("AffiliateOrder"), t("ReturnCustomerOrder"), t("CouponOrder"), t("SharedCart"), t("AdminTaggedOrder")];
    var barLabel = (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) ? __spreadArray(__spreadArray([], baseBarLabel, true), [t("TaggedCompanyLocationOrder")], false) : baseBarLabel;
    var performance_Details_Headers = [
        { name: t("Dashboard_Month"), hide: false },
        { name: t("Dashboard_Orders_Total"), hide: false },
        { name: t("Dashboard_Total_Sale"), hide: false },
        { name: t("Dashboard_Commission"), hide: false },
        { name: t("Dashboard_Bonus"), hide: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.Bonus) },
    ];
    var _q = useState({ commissionMonthLabels: [], commissionMonthPoints: [] }), commissionMonthData = _q[0], setCommissionMonthData = _q[1];
    var _r = useState({ orderMonthLabels: [], orderMonthPoints: [] }), orderMonthData = _r[0], setOrderMonthData = _r[1];
    var _s = useState({ salesMonthLabels: [], salesMonthPoints: [] }), salesSixMonths = _s[0], setSalesSixMonths = _s[1];
    var _t = useState([]), orderFeature = _t[0], setOrderFeature = _t[1];
    var _u = useState([]), commissionFeature = _u[0], setCommissionFeature = _u[1];
    var _v = useState([]), salesFeature = _v[0], setSalesFeature = _v[1];
    var _w = useState(setChartDataFromStore ? setChartDataFromStore : ""), salesRepData = _w[0], setSalesRepData = _w[1];
    var _x = useState(false), openCommissionDialog = _x[0], setOpenCommissionDialog = _x[1];
    var _y = useState({ orderFeatureLabels: 0, commissionFeatureLabels: 0, salesFeatureLabels: 0 }), tempSumArray = _y[0], setTempSumArray = _y[1];
    var _z = useState("-"), currentMonth = _z[0], setCurrentMonth = _z[1];
    var _0 = useState(false), drawerStatus = _0[0], setDrawerStatus = _0[1];
    var _1 = useState([]), currentMonthCommissionDetails = _1[0], setCurrentMonthCommissionDetails = _1[1];
    var _2 = useState(false), performanceDetailsPopup = _2[0], setPerformanceDetailsPopup = _2[1];
    var _3 = useState([]), salesRepMonthlyPerformance = _3[0], setSalesRepMonthlyPerformance = _3[1];
    var _4 = useState(""), commissionSearchText = _4[0], setCommissionSearchText = _4[1];
    var _5 = useState(null), filteredCommissionData = _5[0], setFilteredCommissionData = _5[1];
    var CommissionDiscountType = (_p = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.CommissionDiscountOn) === null || _p === void 0 ? void 0 : _p.CommissionDiscountType;
    var isMobile = useDeviceQueries();
    var dataLine = {
        labels: orderMonthData === null || orderMonthData === void 0 ? void 0 : orderMonthData.orderMonthLabels,
        datasets: [
            {
                type: "line",
                data: orderMonthData === null || orderMonthData === void 0 ? void 0 : orderMonthData.orderMonthPoints,
                borderColor: "#4ED8DA",
                borderWidth: 3,
                datalabels: {
                    display: true,
                    color: "black",
                    align: "top",
                    anchor: "end",
                },
            },
        ],
    };
    var optionsLine = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                padding: {
                    bottom: 20,
                },
            },
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                },
                offset: true,
            },
            y: {
                beginAtZero: true,
                min: 0,
                suggestedMax: 2,
                ticks: {
                    stepSize: 0.2,
                },
            },
        },
    };
    var commissionMonthBar = {
        labels: commissionMonthData === null || commissionMonthData === void 0 ? void 0 : commissionMonthData.commissionMonthLabels,
        datasets: [
            {
                data: commissionMonthData === null || commissionMonthData === void 0 ? void 0 : commissionMonthData.commissionMonthPoints,
                backgroundColor: "#36A2EB",
                barThickness: 35,
                datalabels: {
                    display: true,
                    color: "black",
                    align: "top",
                    anchor: "end",
                    formatter: function (value) { return formatAmount(value, currency, shopCurrency); },
                },
            },
        ],
    };
    var optionsCommissionMonthBar = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                padding: {
                    bottom: 20,
                },
            },
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (context) { return formatAmount(context.parsed.y, currency, shopCurrency); },
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                },
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: true,
                min: 0,
                suggestedMax: 2,
                ticks: {
                    stepSize: 0.2,
                    callback: function (value) { return formatAmount(value, currency, shopCurrency); },
                },
            },
        },
    };
    var salesData = salesSixMonths === null || salesSixMonths === void 0 ? void 0 : salesSixMonths.salesMonthPoints;
    // Calculate the maximum value from data
    var maxSalesValue = Math.max.apply(Math, salesData);
    var xAxisMax = maxSalesValue * 1.15; // Add 15% buffer
    var sixMonthsBar = {
        type: "horizontalBar",
        labels: salesSixMonths === null || salesSixMonths === void 0 ? void 0 : salesSixMonths.salesMonthLabels,
        datasets: [
            {
                data: salesData,
                backgroundColor: "#2371CB",
                barThickness: 25,
                datalabels: {
                    display: true,
                    color: "black",
                    align: "right",
                    anchor: "end",
                    formatter: function (value) { return formatAmount(value, currency, shopCurrency); },
                },
            },
        ],
    };
    var optionSixMonthsBar = {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
            },
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (context) { return formatAmount(context.parsed.x, currency, shopCurrency); },
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                },
                type: "linear",
                max: xAxisMax,
                ticks: {
                    callback: function (value) { return formatAmount(value, currency, shopCurrency); },
                },
            },
            y: {
                title: {
                    display: false,
                },
                grid: {
                    display: false,
                },
            },
        },
    };
    var ordersFeatureBar = {
        labels: (tempSumArray === null || tempSumArray === void 0 ? void 0 : tempSumArray.orderFeatureLabels) > 0 ? barLabel : [],
        datasets: [
            {
                data: orderFeature,
                backgroundColor: "#8566FB",
                barThickness: 35,
                datalabels: {
                    display: true,
                    color: "black",
                    align: "top",
                    anchor: "end",
                },
            },
        ],
    };
    var optionsOrdersFeatureBar = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            title: {
                display: true,
                padding: {
                    bottom: 20,
                },
            },
            legend: {
                display: false,
            },
        },
        scales: {
            y: {
                title: {
                    display: true,
                },
                ticks: {
                    callback: function (label) {
                        return label;
                    },
                },
            },
            x: {
                title: {
                    display: true,
                },
            },
        },
    };
    var commisionFeaturePie = {
        type: "pie",
        labels: (tempSumArray === null || tempSumArray === void 0 ? void 0 : tempSumArray.commissionFeatureLabels) > 0 ? barLabel : [],
        datasets: [
            {
                data: commissionFeature,
                backgroundColor: ["#4ED8DA", "#EAF0B7", "#36A2EB", "#FAD9FF", "#F9A48E", "#73BF53", "#FFA500"],
                borderWidth: 2,
            },
        ],
    };
    var optionsCommisionFeaturePie = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
            display: true,
            position: "top",
            padding: {
                bottom: 20,
            },
        },
        plugins: {
            title: {
                display: true,
                position: "top",
                padding: {
                    bottom: 20,
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context) { return "".concat(context.label, ": ").concat(formatAmount(context.parsed, currency, shopCurrency)); },
                },
            },
            legend: {
                display: (tempSumArray === null || tempSumArray === void 0 ? void 0 : tempSumArray.commissionFeatureLabels) > 0,
                position: isMobile ? "bottom" : "left",
                labels: {
                    usePointStyle: true,
                    PointStyle: "rect",
                    filter: function (legendItem, data) { var _a; return ((_a = data === null || data === void 0 ? void 0 : data.datasets[0]) === null || _a === void 0 ? void 0 : _a.data[legendItem === null || legendItem === void 0 ? void 0 : legendItem.index]) !== 0; },
                    border: "1px solid",
                },
                title: {
                    display: true,
                    position: "center",
                    text: t("Graph_FeatureWiseOrder_XAxisTitle"),
                    padding: {
                        top: 20,
                    },
                },
            },
        },
    };
    var headerMap = {
        ProductType: {
            first: "Product Type",
            second: "Commission",
        },
        Product: {
            first: "Product Name",
            second: "Commission",
        },
        Collection: {
            first: "Collection Name",
            second: "Commission",
        },
        TieredGroup: {
            first: "Tiers",
            second: "Percentage",
        },
        FirstOrderRecurringOrder: {
            first: "Order Type",
            second: "Commission (%)",
        },
    };
    useEffect(function () {
        var _a;
        checkDrawerOpen.subscribe(function (data) {
            setDrawerStatus(data);
        });
        setSalesRepMonthlyPerformance((salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.SalesRepMonthlyCommission) && ((_a = Object.keys((salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.SalesRepMonthlyCommission) || {})) === null || _a === void 0 ? void 0 : _a.map(function (key) { return salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.SalesRepMonthlyCommission[key]; })));
        setCommissionDetails();
    }, [drawerStatus, salesRepData]);
    useEffect(function () {
        var _a;
        if (storeBaseData && ((_a = Object.keys(storeBaseData)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setGraphData();
        }
    }, [storeBaseData]);
    var callDefaultFunctions = function () { return __awaiter(_this, void 0, void 0, function () {
        var ST_Price_Feature, _a, dateFrom, dateTo;
        var _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!(((_b = Object.keys(storeBaseData)) === null || _b === void 0 ? void 0 : _b.length) === 0 || drawerStatus)) return [3 /*break*/, 4];
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(getSalesRepBaseData())];
                case 1:
                    _j.sent();
                    setCommissionDetails();
                    // setGraphData();
                    isLoading.next(false);
                    ST_Price_Feature = ((_e = (_d = (_c = store === null || store === void 0 ? void 0 : store.getState()) === null || _c === void 0 ? void 0 : _c.salesRepData) === null || _d === void 0 ? void 0 : _d.baseData) === null || _e === void 0 ? void 0 : _e.select) ? (_h = (_g = (_f = store === null || store === void 0 ? void 0 : store.getState()) === null || _f === void 0 ? void 0 : _f.salesRepData) === null || _g === void 0 ? void 0 : _g.baseData) === null || _h === void 0 ? void 0 : _h.select : {};
                    if (!ST_Price_Feature.PriceList) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(GetAllWholesalePrices())];
                case 2:
                    _j.sent();
                    _j.label = 3;
                case 3:
                    if (!_stReportsBootstrapDispatched) {
                        _stReportsBootstrapDispatched = true;
                        _a = getSTOrderDetailsDefaultDateRangeApiKeys(), dateFrom = _a.dateFrom, dateTo = _a.dateTo;
                        dispatch(getSalesRepSTReports({
                            dateFrom: dateFrom,
                            dateTo: dateTo,
                            pageSize: ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE,
                            activeTab: "All",
                            pageNumber: 1,
                        }));
                    }
                    _j.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var setCommissionDetails = function () {
        var _a, _b, _c, _d;
        var setChartDataFromStore = (_b = (_a = store === null || store === void 0 ? void 0 : store.getState()) === null || _a === void 0 ? void 0 : _a.salesRepData) === null || _b === void 0 ? void 0 : _b.baseData;
        var month = (setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders) ? (_d = (_c = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders[0]) === null || _c === void 0 ? void 0 : _c.Month) !== null && _d !== void 0 ? _d : "-" : "-";
        if (month != "-") {
            setCurrentMonthCommissionDetails(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.SalesRepMonthlyCommission[month]);
        }
        else {
            setCurrentMonthCommissionDetails([]);
        }
    };
    var setGraphData = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16;
        if (storeBaseData && ((_a = Object.keys(storeBaseData)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setChartDataFromStore = (_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.baseData;
            setCurrentMonth((setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders) ? (_d = (_c = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders[0]) === null || _c === void 0 ? void 0 : _c.Month) !== null && _d !== void 0 ? _d : "-" : "-");
            setSalesRepData(setChartDataFromStore);
            if (setChartDataFromStore) {
                // six month commission w.r.t months
                var commissionMonthNames_1 = [];
                var orderMonthNames_1 = [];
                var salesSixMonthNames_1 = [];
                var commissionMonthValues_1 = [];
                var orderMonthValues_1 = [];
                var salesSixMonthValues_1 = [];
                (setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.SalesRepMonthlyCommission) &&
                    ((_e = Object.entries(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.SalesRepMonthlyCommission)) === null || _e === void 0 ? void 0 : _e.forEach(function (_a) {
                        var _b;
                        var month = _a[0], commissionDetails = _a[1];
                        commissionMonthNames_1.push(month);
                        orderMonthNames_1.push(month);
                        salesSixMonthNames_1.push(month);
                        commissionMonthValues_1.push((_b = commissionDetails === null || commissionDetails === void 0 ? void 0 : commissionDetails.TotalCommission) === null || _b === void 0 ? void 0 : _b.toFixed(2));
                        orderMonthValues_1.push(commissionDetails === null || commissionDetails === void 0 ? void 0 : commissionDetails.TotalNoOfOrders);
                        salesSixMonthValues_1.push(commissionDetails === null || commissionDetails === void 0 ? void 0 : commissionDetails.TotalSale);
                    }));
                setCommissionMonthData({ commissionMonthLabels: commissionMonthNames_1.reverse(), commissionMonthPoints: commissionMonthValues_1.reverse() });
                setOrderMonthData({ orderMonthLabels: orderMonthNames_1.reverse(), orderMonthPoints: orderMonthValues_1.reverse() });
                setSalesSixMonths({
                    salesMonthLabels: salesSixMonthNames_1.reverse(),
                    salesMonthPoints: salesSixMonthValues_1 === null || salesSixMonthValues_1 === void 0 ? void 0 : salesSixMonthValues_1.map(function (value) { return parseFloat(value === null || value === void 0 ? void 0 : value.toFixed(2)); }).reverse(),
                });
                // feature wise orders
                if (setChartDataFromStore && ((_f = Object.keys(setChartDataFromStore)) === null || _f === void 0 ? void 0 : _f.length) > 0) {
                    var Client_Invoice_Orders = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders) ? (_g = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders[0]) === null || _g === void 0 ? void 0 : _g.CustomerOrderCount : 0;
                    var Affiliate_Link_Orders = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepAffiliateOrders) ? (_h = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepAffiliateOrders[0]) === null || _h === void 0 ? void 0 : _h.AffiliateOrderCount : 0;
                    var Refund_Customer_Orders = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCustomerOrdersDetails)
                        ? (_j = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCustomerOrdersDetails[0]) === null || _j === void 0 ? void 0 : _j.TagCustomerOrderCount
                        : 0;
                    var Discount_Coupon_Orders = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCouponOrders) ? (_k = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCouponOrders[0]) === null || _k === void 0 ? void 0 : _k.CouponCodeOrderCount : 0;
                    var Shared_Cart_Orders = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepSharedCart) ? (_l = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepSharedCart[0]) === null || _l === void 0 ? void 0 : _l.OrderCount : 0;
                    var AdminTagged_Orders = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.AdminTaggedOrdersDetails) ? (_m = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.AdminTaggedOrdersDetails[0]) === null || _m === void 0 ? void 0 : _m.TagOrderCount : 0;
                    var CompanyLocation_TaggedOrders = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCompanyLocationOrdersDetails)
                        ? (_o = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCompanyLocationOrdersDetails[0]) === null || _o === void 0 ? void 0 : _o.OrderCount
                        : 0;
                    var totalOrders_1 = Client_Invoice_Orders + Affiliate_Link_Orders + Refund_Customer_Orders + Discount_Coupon_Orders + Shared_Cart_Orders + AdminTagged_Orders;
                    var orderFeatureArray = [Client_Invoice_Orders, Affiliate_Link_Orders, Refund_Customer_Orders, Discount_Coupon_Orders, Shared_Cart_Orders, AdminTagged_Orders];
                    // Check B2B feature to add order
                    if (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) {
                        totalOrders_1 += CompanyLocation_TaggedOrders;
                        orderFeatureArray.push(CompanyLocation_TaggedOrders);
                    }
                    setTempSumArray(function (values) { return (__assign(__assign({}, values), { orderFeatureLabels: totalOrders_1 })); });
                    setOrderFeature(orderFeatureArray);
                    // feature wise commission
                    var Client_Invoice_Commission = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders)
                        ? parseFloat((_r = (_q = (_p = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders[0]) === null || _p === void 0 ? void 0 : _p.CustomerOrderCommission) === null || _q === void 0 ? void 0 : _q.toFixed(2)) !== null && _r !== void 0 ? _r : 0)
                        : 0;
                    var Affiliate_Link_Commission = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepAffiliateOrders)
                        ? parseFloat((_u = (_t = (_s = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepAffiliateOrders[0]) === null || _s === void 0 ? void 0 : _s.AffiliateOrderCommission) === null || _t === void 0 ? void 0 : _t.toFixed(2)) !== null && _u !== void 0 ? _u : 0)
                        : 0;
                    var Refund_Customer_Commission = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCustomerOrdersDetails)
                        ? parseFloat((_x = (_w = (_v = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCustomerOrdersDetails[0]) === null || _v === void 0 ? void 0 : _v.TagCustomerCommission) === null || _w === void 0 ? void 0 : _w.toFixed(2)) !== null && _x !== void 0 ? _x : 0)
                        : 0;
                    var Discount_Coupon_Commission = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCouponOrders)
                        ? parseFloat((_0 = (_z = (_y = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCouponOrders[0]) === null || _y === void 0 ? void 0 : _y.CouponCodeOrderCommission) === null || _z === void 0 ? void 0 : _z.toFixed(2)) !== null && _0 !== void 0 ? _0 : 0)
                        : 0;
                    var Shared_Cart_Commission = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepSharedCart)
                        ? parseFloat((_3 = (_2 = (_1 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepSharedCart[0]) === null || _1 === void 0 ? void 0 : _1.OrderCommission) === null || _2 === void 0 ? void 0 : _2.toFixed(2)) !== null && _3 !== void 0 ? _3 : 0)
                        : 0;
                    var AdminTagged_Commission = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.AdminTaggedOrdersDetails)
                        ? parseFloat((_6 = (_5 = (_4 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.AdminTaggedOrdersDetails[0]) === null || _4 === void 0 ? void 0 : _4.TagOrderCommission) === null || _5 === void 0 ? void 0 : _5.toFixed(2)) !== null && _6 !== void 0 ? _6 : 0)
                        : 0;
                    var CompanyLocationTagged_Commission = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCompanyLocationOrdersDetails)
                        ? parseFloat((_9 = (_8 = (_7 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCompanyLocationOrdersDetails[0]) === null || _7 === void 0 ? void 0 : _7.OrderCommission) === null || _8 === void 0 ? void 0 : _8.toFixed(2)) !== null && _9 !== void 0 ? _9 : 0)
                        : 0;
                    var totalCommission_1 = Client_Invoice_Commission + Affiliate_Link_Commission + Refund_Customer_Commission + Discount_Coupon_Commission + Shared_Cart_Commission + AdminTagged_Commission;
                    var commissionFeatureArray = [
                        Client_Invoice_Commission,
                        Affiliate_Link_Commission,
                        Refund_Customer_Commission,
                        Discount_Coupon_Commission,
                        Shared_Cart_Commission,
                        AdminTagged_Commission,
                    ];
                    // Check B2B feature to add commition
                    if (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) {
                        totalCommission_1 += CompanyLocationTagged_Commission;
                        commissionFeatureArray.push(CompanyLocationTagged_Commission);
                    }
                    setTempSumArray(function (values) { return (__assign(__assign({}, values), { commissionFeatureLabels: totalCommission_1 })); });
                    setCommissionFeature(commissionFeatureArray);
                    // sales wise feature for current month
                    var Client_Invoice_Sales = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders) ? (_10 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCustomerOrders[0]) === null || _10 === void 0 ? void 0 : _10.CustomerOrderSubtotal : 0;
                    var Affiliate_Link_Sales = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepAffiliateOrders)
                        ? (_11 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepAffiliateOrders[0]) === null || _11 === void 0 ? void 0 : _11.AffiliateOrderSubTotal
                        : 0;
                    var Refund_Customer_Sales = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCustomerOrdersDetails)
                        ? (_12 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCustomerOrdersDetails[0]) === null || _12 === void 0 ? void 0 : _12.TagCustomerSubTotal
                        : 0;
                    var Discount_Coupon_Sales = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCouponOrders) ? (_13 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepCouponOrders[0]) === null || _13 === void 0 ? void 0 : _13.CouponCodeOrderSubtotal : 0;
                    var Shared_Cart_Sales = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepSharedCart) ? (_14 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.salesrepSharedCart[0]) === null || _14 === void 0 ? void 0 : _14.OrderSubTotal : 0;
                    var AdminTagged_Sales = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.AdminTaggedOrdersDetails) ? (_15 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.AdminTaggedOrdersDetails[0]) === null || _15 === void 0 ? void 0 : _15.TagOrderSubTotal : 0;
                    var CompanyLocationTagged_Sales = handleNullCheck(setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCompanyLocationOrdersDetails)
                        ? (_16 = setChartDataFromStore === null || setChartDataFromStore === void 0 ? void 0 : setChartDataFromStore.TaggedCompanyLocationOrdersDetails[0]) === null || _16 === void 0 ? void 0 : _16.OrderSubTotal
                        : 0;
                    var totalSales_1 = Client_Invoice_Sales + Affiliate_Link_Sales + Refund_Customer_Sales + Discount_Coupon_Sales + Shared_Cart_Sales + AdminTagged_Sales;
                    var salesFeatureArray = [Client_Invoice_Sales, Affiliate_Link_Sales, Refund_Customer_Sales, Discount_Coupon_Sales, Shared_Cart_Sales, AdminTagged_Sales];
                    // Check B2B feature to add order sales
                    if (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) {
                        totalSales_1 += CompanyLocationTagged_Sales;
                        salesFeatureArray.push(CompanyLocationTagged_Sales);
                    }
                    setTempSumArray(function (values) { return (__assign(__assign({}, values), { salesFeatureLabels: totalSales_1 })); });
                    setSalesFeature(salesFeatureArray);
                }
            }
        }
    };
    var getProductAndVariantNames = function (productNameWithVariant) {
        var _a, _b, _c, _d;
        try {
            if (!productNameWithVariant) {
                return { productName: "-", variantName: "" };
            }
            var _e = (_a = productNameWithVariant === null || productNameWithVariant === void 0 ? void 0 : productNameWithVariant.split("_")) !== null && _a !== void 0 ? _a : [], rawProductName = _e[0], variantParts = _e.slice(1);
            var productName = (_b = rawProductName === null || rawProductName === void 0 ? void 0 : rawProductName.trim()) !== null && _b !== void 0 ? _b : "-";
            var variantName = (_d = (_c = variantParts === null || variantParts === void 0 ? void 0 : variantParts.join("_")) === null || _c === void 0 ? void 0 : _c.trim()) !== null && _d !== void 0 ? _d : "";
            return { productName: productName, variantName: variantName };
        }
        catch (error) {
            return { productName: "-", variantName: "" };
        }
    };
    var getCommissionStructure = function (commissionArray, labelKey, valueKey) {
        try {
            // Add null check for commissionArray
            if (!commissionArray) {
                return (_jsx(TableBody, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ align: "center", colSpan: 2 }, { children: t("Graph_SalesRepCommission_nocommissiontitle") })) }) }));
            }
            // Use filtered data if available, otherwise use original data
            var displayData = filteredCommissionData !== null ? filteredCommissionData : commissionArray;
            var tempCommissisonStructure = displayData && (displayData === null || displayData === void 0 ? void 0 : displayData.length) > 0 ? (_jsx(TableBody, { children: displayData === null || displayData === void 0 ? void 0 : displayData.map(function (item, index) {
                    var _a, _b;
                    var isProductCommission = labelKey && labelKey === "ProductName";
                    var _c = isProductCommission ? getProductAndVariantNames(item === null || item === void 0 ? void 0 : item[labelKey]) : { productName: "", variantName: "" }, productName = _c.productName, variantName = _c.variantName;
                    return (_jsxs(TableRow, { children: [_jsx(TableCell, __assign({ className: "ST_Commission_Product_Cell", sx: { whiteSpace: "normal", verticalAlign: "top" } }, { children: isProductCommission ? (_jsxs(Box, __assign({ className: "ST_Variant_Chip_Box" }, { children: [_jsx(Typography, __assign({ variant: "body2", fontWeight: 400, className: "ST_Commission_Product_Title" }, { children: productName })), variantName && _jsx(Chip, { size: "small", label: variantName, className: "ST_Variant_Chip" })] }))) : (labelKey === "targetedAmount"
                                    ? "".concat(t("Above"), ": ").concat(formatAmount(item[labelKey], currency, shopCurrency))
                                    : item[labelKey]) })), _jsx(TableCell, __assign({ align: "center", className: "ST_White_Space" }, { children: CommissionDiscountType === "FixedDollarAmount" ? formatAmount(item[valueKey], currency, shopCurrency) : ((_a = item[valueKey]) === null || _a === void 0 ? void 0 : _a.toFixed(2)) + "%" }))] }, (_b = item === null || item === void 0 ? void 0 : item.variantId) !== null && _b !== void 0 ? _b : index));
                }) })) : (_jsx(TableBody, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ align: "center", colSpan: 2 }, { children: t(labelKey != "targetedAmount" ? "Graph_SalesRepCommission_nocommissiontitle" : "No_tiers_available") })) }) }));
            return tempCommissisonStructure;
        }
        catch (error) {
            return (_jsx(TableBody, { children: _jsx(TableRow, { children: _jsx(TableCell, __assign({ align: "center", colSpan: 2 }, { children: t("Graph_SalesRepCommission_nocommissiontitle") })) }) }));
        }
    };
    // Commission search functionality
    var handleCommissionSearch = function (searchValue, commissionType) {
        var _a, _b;
        try {
            // Early return for invalid parameters
            if (!commissionType) {
                setCommissionSearchText("");
                setFilteredCommissionData(null);
                return;
            }
            // Always update the search text state
            setCommissionSearchText(searchValue);
            // Early return for empty search
            if (!(searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim())) {
                setFilteredCommissionData(null);
                return;
            }
            var searchTerm_1 = searchValue.toLowerCase().trim();
            // Configuration object for commission types and their data sources
            var commissionConfig = {
                ProductType: {
                    data: salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.CommissionandDiscountPerProductType,
                    searchField: "productType",
                },
                Collection: {
                    data: salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.CommissionandDiscountPerCollection,
                    searchField: "CollectionName",
                },
                Product: {
                    data: salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.CommissionandDiscountPerProduct,
                    searchField: "ProductName",
                },
                TieredGroup: {
                    data: (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.CurrentTieredGroupCommissionDetails) === null || _a === void 0 ? void 0 : _a.allTiereds,
                    searchField: "targetedAmount",
                },
            };
            var config_1 = commissionConfig[commissionType];
            var filteredData = (_b = config_1 === null || config_1 === void 0 ? void 0 : config_1.data) === null || _b === void 0 ? void 0 : _b.filter(function (item) {
                var fieldValue = item[config_1.searchField];
                return fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.toString().toLowerCase().includes(searchTerm_1);
            });
            setFilteredCommissionData(filteredData);
        }
        catch (error) {
            console.error("Error in handleCommissionSearch:", error);
            // Reset states on error to prevent inconsistent UI state
            setCommissionSearchText("");
            setFilteredCommissionData(null);
        }
    };
    var clearCommissionSearch = function () {
        setCommissionSearchText("");
        setFilteredCommissionData(null);
    };
    var getTimeZone = function () {
        var todaysDate = new Date();
        var current_hrs = todaysDate.getHours();
        var timeZone = current_hrs < 12 ? t("dashboard_morningMsg") : current_hrs < 18 ? t("dashboard_afternoonMsg") : t("dashboard_eveningMsg");
        return timeZone;
    };
    var showNoDataMessage = function (graphNo) {
        var arrayName = [];
        switch (graphNo) {
            case 1:
                arrayName = orderFeature;
                break;
            case 2:
                arrayName = commissionFeature;
                break;
            case 3:
                arrayName = orderMonthData === null || orderMonthData === void 0 ? void 0 : orderMonthData.orderMonthPoints;
                break;
            case 4:
                arrayName = commissionMonthData === null || commissionMonthData === void 0 ? void 0 : commissionMonthData.commissionMonthPoints;
                break;
            case 5:
                arrayName = salesSixMonths === null || salesSixMonths === void 0 ? void 0 : salesSixMonths.salesMonthPoints;
                break;
            case 6:
                arrayName = salesFeature;
                break;
        }
        var tempDataStructure = (_jsx(Typography, __assign({ variant: "body2", className: "ST_DB_No_Data", hidden: checkTotal(arrayName) }, { children: t("dashboard_no_data") })));
        return tempDataStructure;
    };
    var checkTotal = function (sumArray) {
        if ((sumArray === null || sumArray === void 0 ? void 0 : sumArray.length) === 0) {
            return false;
        }
        var summation = sumArray.reduce(function (a, b) { return parseFloat(a) + parseFloat(b); }, 0);
        return summation != 0 ? true : false;
    };
    var totalCommissionPie = commissionFeature === null || commissionFeature === void 0 ? void 0 : commissionFeature.reduce(function (commissions, value) { return commissions + (value !== null && value !== void 0 ? value : 0); }, 0);
    var totalRevenue = salesSixMonths === null || salesSixMonths === void 0 ? void 0 : salesSixMonths.salesMonthPoints.reduce(function (sales, value) { return sales + (value !== null && value !== void 0 ? value : 0); }, 0);
    var avgTicketSize = totalRevenue / (orderMonthData === null || orderMonthData === void 0 ? void 0 : orderMonthData.orderMonthPoints.reduce(function (orders, value) { return orders + (value !== null && value !== void 0 ? value : 0); }, 0)) || 0;
    var handlePerformanceDetailsPopup = function () {
        setPerformanceDetailsPopup(!performanceDetailsPopup);
    };
    var handleNullCheck = function (acceptValues) {
        return acceptValues && (acceptValues === null || acceptValues === void 0 ? void 0 : acceptValues.length) != 0;
    };
    return {
        callDefaultFunctions: callDefaultFunctions,
        currentMonth: currentMonth,
        dataLine: dataLine,
        optionsLine: optionsLine,
        sixMonthsBar: sixMonthsBar,
        optionSixMonthsBar: optionSixMonthsBar,
        commissionMonthBar: commissionMonthBar,
        optionsCommissionMonthBar: optionsCommissionMonthBar,
        ordersFeatureBar: ordersFeatureBar,
        optionsOrdersFeatureBar: optionsOrdersFeatureBar,
        commisionFeaturePie: commisionFeaturePie,
        optionsCommisionFeaturePie: optionsCommisionFeaturePie,
        salesRepData: salesRepData,
        openCommissionDialog: openCommissionDialog,
        setOpenCommissionDialog: setOpenCommissionDialog,
        getCommissionStructure: getCommissionStructure,
        loggedInRepData: loggedInRepData,
        getTimeZone: getTimeZone,
        showNoDataMessage: showNoDataMessage,
        t: t,
        shopCurrency: shopCurrency,
        currentMonthCommissionDetails: currentMonthCommissionDetails,
        totalCommissionPie: totalCommissionPie,
        totalRevenue: totalRevenue,
        avgTicketSize: avgTicketSize,
        isDesktop: isDesktop,
        performanceDetailsPopup: performanceDetailsPopup,
        setPerformanceDetailsPopup: setPerformanceDetailsPopup,
        handlePerformanceDetailsPopup: handlePerformanceDetailsPopup,
        salesRepMonthlyPerformance: salesRepMonthlyPerformance,
        performance_Details_Headers: performance_Details_Headers,
        selectFeatures: selectFeatures,
        ShopBusinessName: ShopBusinessName,
        currency: currency,
        headerMap: headerMap,
        CommissionDiscountType: CommissionDiscountType,
        commissionSearchText: commissionSearchText,
        handleCommissionSearch: handleCommissionSearch,
        clearCommissionSearch: clearCommissionSearch,
    };
}
export function DashboardCssConstants() {
    var isDesktop = useMediaQuery("(min-width: 1360px)");
    var isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
    var isMobile = useMediaQuery("(max-width: 767px)");
    var isMediumScreen = useMediaQuery("(min-width: 1025px) and (max-width: 1359px)");
    var ST_DB_Min_Cards = {
        p: "0px !important",
        height: isMobile ? "120px" : isTablet ? "110px" : isMediumScreen ? "100px" : "95px",
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "0.5px solid #98C6CD !important",
        minHeight: isMobile ? "120px" : isTablet ? "110px" : isMediumScreen ? "100px" : "95px",
    };
    var ST_DB_Card_Grid_Layout = __assign(__assign({}, ST_DB_Min_Cards), { display: "flex", alignItems: "center" });
    var ST_DB_Min_CardsTicket = {
        mb: 2,
        p: "0px !important",
        height: "170px",
        boxShadow: "none",
    };
    var ST_DB_cardText_Font = {
        fontSize: isTablet || isMobile ? 11 : 13,
        fontWeight: "bold",
        alignItems: "center",
    };
    var ST_DB_Graph_CardTotal = {
        fontSize: 18,
        fontWeight: "bold",
        marginLeft: "0.6rem",
        mr: 1,
        mb: 0,
    };
    var ST_DB_Graph_catrdTotal_Text = {
        color: "#ffffff",
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "fit-content",
        minWidth: "6rem",
        height: "3rem",
        fontSize: "2rem",
        padding: "0 1.5rem",
        borderRadius: "2px",
    };
    var info_Msg_fontSize = {
        fontWeight: "bold",
        fontSize: "14px",
        mb: isDesktop ? 0 : 1,
        textAlign: "left",
    };
    return {
        ST_DB_Card_Grid_Layout: ST_DB_Card_Grid_Layout,
        ST_DB_Graph_CardTotal: ST_DB_Graph_CardTotal,
        ST_DB_cardText_Font: ST_DB_cardText_Font,
        ST_DB_Graph_catrdTotal_Text: ST_DB_Graph_catrdTotal_Text,
        ST_DB_Min_CardsTicket: ST_DB_Min_CardsTicket,
        info_Msg_fontSize: info_Msg_fontSize,
    };
}
